import { atom, selector } from 'recoil';

export const adIdAtom = atom({
  key: 'adIdAtom',
  default: null,
});